/*
 * SERAF: desktop hover + keyboard support for Fullstack dropdown mega-menus.
 */

const hoverDelay = 100;

class SerafMegaMenuController {
  constructor(dropdown) {
    this.dropdown = dropdown;
    this.timer = null;
    this.toggle = dropdown.querySelector('[data-ref="dropdown-toggle"]');
    this.content = dropdown.querySelector('[data-ref="dropdown-content"]');
    this.bind();
  }

  bind() {
    this.dropdown.addEventListener('mouseenter', () => this.openSoon());
    this.dropdown.addEventListener('mouseleave', () => this.closeSoon());
    this.dropdown.addEventListener('keydown', (event) => this.onKeydown(event));
    this.toggle?.setAttribute('aria-haspopup', 'true');
    this.toggle?.setAttribute('aria-expanded', 'false');
  }

  openSoon() {
    if (!window.matchMedia('(min-width: 1001px)').matches) return;
    window.clearTimeout(this.timer);
    this.timer = window.setTimeout(() => this.open(), hoverDelay);
  }

  closeSoon() {
    if (!window.matchMedia('(min-width: 1001px)').matches) return;
    window.clearTimeout(this.timer);
    this.timer = window.setTimeout(() => this.close(), hoverDelay);
  }

  open() {
    this.dropdown.closest('dropdown-group-component')?.closeAllDropdowns();
    this.dropdown.open?.();
    this.toggle?.setAttribute('aria-expanded', 'true');
  }

  close() {
    this.dropdown.close?.();
    this.toggle?.setAttribute('aria-expanded', 'false');
  }

  onKeydown(event) {
    if (event.key === 'Escape') {
      this.close();
      this.toggle?.focus();
    }
  }
}

document.querySelectorAll('dropdown-component.seraf-nav-item').forEach((dropdown) => {
  if (!dropdown.dataset.serafMegaReady) {
    dropdown.dataset.serafMegaReady = 'true';
    new SerafMegaMenuController(dropdown);
  }
});
